"use client";

import { NavigateOptions } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { useRouter as useNextRouter } from "next/navigation";
import { cleanHrefWithSiteBasePath } from "./clean-href-with-site-base-path";
import { useRouterContext } from "./context";
import { isSupportedRouterNavigation } from "./is-supported-router-navigation";

export const useRouter = () => {
  const nextRouter = useNextRouter();
  const { appRouterPathPrefixes, siteBasePath } = useRouterContext();

  return {
    ...nextRouter,
    push: (to: string, options?: NavigateOptions) => {
      const isSupportedRouterNavigationForCurrentPage =
        isSupportedRouterNavigation({
          appRouterPathPrefixes,
          siteBasePath,
          to,
        });

      const siteBasePathTo = cleanHrefWithSiteBasePath({
        href: to,
        siteBasePath,
      });

      if (isSupportedRouterNavigationForCurrentPage) {
        nextRouter.push(siteBasePathTo, options);
      } else {
        window.location.href = `${window.location.origin}${siteBasePathTo}`;
      }
    },
    replace: (to: string, options?: NavigateOptions) => {
      const isSupportedRouterNavigationForCurrentPage =
        isSupportedRouterNavigation({
          appRouterPathPrefixes,
          siteBasePath,
          to,
        });

      const siteBasePathTo = cleanHrefWithSiteBasePath({
        href: to,
        siteBasePath,
      });

      if (isSupportedRouterNavigationForCurrentPage) {
        nextRouter.replace(siteBasePathTo, options);
      } else {
        window.location.replace(`${window.location.origin}${siteBasePathTo}`);
      }
    },
  };
};
